import { FC } from 'react';
import useStyles from './useStyles';
import { Box } from '@mui/material';

interface MaskBackgroundProps {
  className:
    | 'filtersDesktopBackground'
    | 'filtersDetailsBackground'
    | 'gridBackground'
    | 'gridBackgroundWishlist';
}

const MaskBackground: FC<MaskBackgroundProps> = ({ className }) => {
  const classes = useStyles();

  return <Box sx={classes[className]} />;
};

export default MaskBackground;
